"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getULink = exports.getUlinkPath = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var launch_1 = require("../../enum/launch");
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
var getUlinkPath = function (isOld) {
    if (isOld === void 0) { isOld = false; }
    if (isOld) {
        return launch_1.EnumUniversalLinkPath.OldProd;
    }
    var path = launch_1.EnumUniversalLinkPath.Prod;
    if ((0, web_base_1.isTestEnv)()) {
        path = launch_1.EnumUniversalLinkPath.Test;
    }
    return path;
};
exports.getUlinkPath = getUlinkPath;
/**
* 生成详情页的Universal link
* @param type
* @param token
* @returns
*/
var getULink = function (type, token, meetingCode) {
    var joinToken = token || '';
    var wtoken = (0, web_base_1.getRequest)('wtoken');
    var ulinkUrl = "".concat((0, exports.getUlinkPath)(), "?type=join&meeting_code=").concat(meetingCode, "&token=").concat(joinToken);
    if ( // 私有化: 国家电网需要增加 tmid 参数
    process.env.WEMEET_PARAM_PRIVATE === 'state-grid') {
        ulinkUrl += "&tmid=".concat(meetingCode);
    }
    if ((0, web_base_1.getRequest)('user_code')) {
        ulinkUrl += "&user_code=".concat((0, web_base_1.getRequest)('user_code'));
    }
    // webinar报名页需要增加uid
    if (!web_base_1.isServer && window.webinarSchemaUserInfoParams) {
        ulinkUrl += window.webinarSchemaUserInfoParams;
    }
    // 添加meeting_type_flags参数
    if (!web_base_1.isServer && window.schemaMeetingTypeFlagsParams) {
        ulinkUrl += window.schemaMeetingTypeFlagsParams;
    }
    if (type === launch_1.EnumLaunchType.LaunchApp) {
        ulinkUrl = "".concat((0, exports.getUlinkPath)(), "?type=launch");
    }
    if (wtoken) {
        ulinkUrl = (0, web_base_1.addURLSearch)(ulinkUrl, {
            webinar_token: wtoken,
        });
    }
    if ((0, web_base_1.getRequest)('rs')) {
        ulinkUrl = (0, web_base_1.addURLSearch)(ulinkUrl, {
            rs: (0, web_base_1.getRequest)('rs'),
        });
    }
    if ((0, web_base_1.getRequest)('cd')) {
        ulinkUrl = (0, web_base_1.addURLSearch)(ulinkUrl, {
            cd: encodeURIComponent((0, web_base_1.getRequest)('cd')),
        });
    }
    init_aegis_1.default.logAll("[met-component-launchapp]getUlinkUrl ".concat(ulinkUrl));
    return ulinkUrl;
};
exports.getULink = getULink;
//# sourceMappingURL=universal-link.js.map